export class Config {
    // enforces all token-related methods to specify tokenaddr as recepient and change cashaddr
    static { this.EnforceCashTokenReceiptAddresses = false; }
    static { this.DefaultParentDerivationPath = "m/44'/0'/0'"; }
    static { this.DefaultIpfsGateway = "https://dweb.link/ipfs/"; }
    // default currency for balance and rate conversions
    static { this.DefaultCurrency = "usd"; }
    // caches the raw transactions in browser's local storage instead of memory
    static { this.UseLocalStorageCache = false; }
    // caches the raw transactions in browser's indexedDB instead of memory
    static { this.UseIndexedDBCache = false; }
    // caches the raw transactions in browser's memory
    static { this.UseMemoryCache = false; }
    static setIpfsGateway(ipfsGateway) {
        this.DefaultIpfsGateway = ipfsGateway;
    }
    // custom exchange rate function
    static { this.GetExchangeRateFn = undefined; }
}
//# sourceMappingURL=config.js.map